import styled from 'styled-components';
import Grid from '../Grid';
import { colors, fonts } from '../../settings';

export const StyledCont = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const StyledGridRow = styled(Grid.Row)`
  margin: 20px 0;
`;
export const NamedDiv = styled.div`&:after {
  content: ' ';
  display: block;
  position: absolute;
  width: 15px;
  height: 15px;
  right: 0;
  top: 50%;
  color: ${colors.black};
}`

export const StyledSelect = styled.select`
  background-color: ${colors.grey1};
  border: none;
  border-radius: 0px;
  width: 100%;
  -webkit-appearance: none;
  padding: 8px;
  font-family: ${fonts.bold};
  color: ${colors.grey2};
  position: relative;
  margin-top: 15px;

  
`;
